<mat-card data-at-remote-diagnostics-reason-for-connection-modal>
  <mat-card-header>
    <mat-card-title class="!flex flex-row justify-between items-center">
      <span>{{ 'DIAGNOSTICS.CONNECTION_MODAL.REASON_COLLECTOR_TITLE' | translate }}</span>
      <mat-icon
        data-at-remote-diagnostics-reason-for-connection-modal-cancel
        gtm="onCancelDialog"
        gtmCategory="diagnosticsModal"
        class="mat-dialog-close"
        [mat-dialog-close]
        >close</mat-icon
      >
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-diagnostics-connection-reason-collector-form
      (formValue)="formValue = $event"
      (formInvalid)="isFormInvalid = $event"
    ></app-diagnostics-connection-reason-collector-form>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-remote-diagnostics-reason-for-connection-modal-proceed
      mat-raised-button
      gtm="onNextStep"
      gtmCategory="diagnosticsModal"
      color="primary"
      (click)="proceedToWarning()"
      [disabled]="isFormInvalid"
    >
      {{ 'GENERAL.BUTTON.CONTINUE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
